var _defs, _path, _g, _g2, _g3, _g4, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-nz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -.325)",
    d: "M0 0v.5L1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.5L1 0z",
    transform: "rotate(-36 .5 -.162)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1) rotate(72)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v300H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00247d",
    d: "M.004 0h512v512h-512z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148.654 134.473) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(45.4 0 0 45.4 900 120)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(30 0 0 30 900 120)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 393.421 127.092) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 519.022 -457.666) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 519.022 -457.666) scale(25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 393.421 127.092) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 668.57 -327.666) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 668.57 -327.666) scale(30)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148.654 134.473) scale(.60566)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(50.4 0 0 50.4 900 480)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(35 0 0 35 900 480)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.52004 0 0 .78924 .002 0)",
    d: "M0 0l600 300M0 300L600 0",
    clipPath: "url(#c)",
    stroke: "#fff",
    strokeWidth: 60
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.52004 0 0 .78924 .002 0)",
    d: "M0 0l600 300M0 300L600 0",
    clipPath: "url(#d)",
    stroke: "#cc142b",
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    clipPath: "url(#c)",
    d: "M125.674-.004v88.049H-.06v60.682h125.733v88.046h60.681v-88.046h125.733V88.045H186.355V-.004h-60.681z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M137.81.002v100.18H-.058v36.408h137.87v100.18h36.408V136.59h137.869v-36.408h-137.87V.002h-36.407z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible",
    fill: "#cc142b"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.7961d9cf25200dd7fbfb03880d0bb534.svg";
export { ForwardRef as ReactComponent };